module.exports = __webpack_public_path__ + "static/img/whyUs.62c576d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whyUs.png
// module id = K2t2
// module chunks = 1